import { useState, useEffect } from "react";

const useOnScreen = (ref, threshold = 0.1) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const currentRef = ref.current; // Store the current value of the ref

    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log(`${currentRef?.id || "Component"} is intersecting:`, entry.isIntersecting);
        setIsIntersecting(entry.isIntersecting);
      },
      { threshold }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref, threshold]);

  return isIntersecting;
};

export default useOnScreen;
